module.exports = __webpack_public_path__ + "img/icon_uploadPhoto.8d63fc18.svg";